export default __webpack_public_path__ + "static/media/sandero-gallery-15.fdf09332.jpg";